export const ScreenMap = [
    { value: "Gig-Assigned", page: "/dashboard" },
    { value: "Acceptance", page: "/gig" },
    { value: "Review-Request", page: "/dashboard/reviews" },
  ];
  